import React from "react";
import { connect } from "react-redux";
import { makeStyles } from "@material-ui/core";
import theme from "styles/theme";

import { formatMessage } from "lib/globalize-util";
import { IProduct } from "records/item/item";
import { BrandRecord } from "records/brand";
import { IStore } from "reducers";
import { getImageSource } from "../helpers";

export interface IProductViewProps {
    product: IProduct;
}

export interface IProductViewStateProps {
    brand: BrandRecord | null;
}

export const ProductViewComponent: React.FC<IProductViewProps & IProductViewStateProps> = ({ product, brand }) => {
    const classes = useStyles();

    if (!product) {
        return null;
    }

    const { name, style_number, color, season } = product;
    const imageSource = getImageSource(brand, product);

    return (
        <div>
            <div className={classes.modalDescription}>
                {formatMessage("Want to apply the customization to more products?")}
            </div>
            <div className={classes.productTitle}>{formatMessage("Original Product")}:</div>
            <div className={classes.productView}>
                <div className={classes.productImageContainer}>
                    <img className={classes.productImage} src={imageSource} alt="Product Image" />
                </div>
                <div className={classes.productName}>{name}</div>
                <div className={classes.productStyleNumber}>{style_number}</div>
                <div className={classes.productSeason}>{season}</div>
                <div className={classes.productColor}>{color}</div>
            </div>
        </div>
    );
};

const mapStateToProps = (state: IStore): IProductViewStateProps => ({
    brand: state?.scope?.brand,
});

export const ProductView = connect<IProductViewStateProps, {}, IProductViewProps>(mapStateToProps)(
    ProductViewComponent
);

const useStyles = makeStyles({
    productView: {
        width: "100%",
        display: "flex",
        flexDirection: "row",
        lineHeight: "70px",
        color: theme.palette.darkestGrey,
        fontSize: "13px",
    },
    productTitle: {
        color: theme.palette.black,
        fontSize: "16px",
        fontWeight: "bold",
    },
    productImageContainer: {
        width: "15%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    productImage: {
        maxWidth: "50px",
    },
    productName: {
        width: "22%",
    },
    productStyleNumber: {
        width: "21%",
    },
    productSeason: {
        width: "21%",
    },
    productColor: {
        width: "21%",
    },
    modalDescription: {
        marginBottom: "15px",
        fontSize: "14px",
        color: theme.palette.darkestGrey,
    },
});
